import React from "react";
import "./contact.css";

export default function Contact() {
  return (
    <div class='ContactInfo'>
      <form class="contact-form" method="#" data-aos="zoom-in-down">
        <h1 style={{ textAlign: "center" }}>Contact Form</h1>
        <div class="form-group">
          <label for="username">Username:</label>
          <input type="text" id="username" name="username" required />
        </div>
        <div class="form-group">
          <label for="email">Email:</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div class="form-group">
          <label for="message">Message:</label>
          <textarea id="message" name="message" required></textarea>
        </div>
        <div class="form-group">
          <button type="submit" className="btn">
            Submit
          </button>
        </div>
      </form>
   
    </div>
  );
}
